var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygonIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "measure-area_svgrepo.com",
    clipPath: "url(#clip0_577_6100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.6696 11.3363H30.0029V7.33626H26.0029V8.6776L7.33626 3.95093V2.00293H3.33626V6.00293H4.6696V14.0029H2.00293V24.6696H4.6696V27.3363H3.33626V31.3363H7.33626V30.0029H26.0029V31.3363H30.0029V27.3363H28.6696V24.6696H31.3363V14.0029H28.6696V11.3363ZM27.3363 8.6696H28.6696V10.0029H27.3363V8.6696ZM4.6696 3.33626H6.00293V4.6696H4.6696V3.33626ZM6.00293 6.00293H7.33626V5.3336L26.0029 10.0603V11.3363H27.3363V14.0029H6.00293V6.00293ZM6.00293 30.0029H4.6696V28.6696H6.00293V30.0029ZM28.6696 30.0029H27.3363V28.6696H28.6696V30.0029ZM27.3363 27.3363H26.0029V28.6696H7.33626V27.3363H6.00293V24.6696H27.3363V27.3363ZM30.0029 15.3363V23.3363H28.6696V19.3363H27.3363V23.3363H26.0029V20.6696H24.6696V23.3363H23.3363V16.6696H22.0029V23.3363H20.6696V20.6696H19.3363V23.3363H18.0029V19.3363H16.6696V23.3363H15.3363V20.6696H14.0029V23.3363H12.6696V16.6696H11.3363V23.3363H10.0029V20.6696H8.6696V23.3363H7.33626V19.3363H6.00293V23.3363H3.33626V15.3363H30.0029Z",
    fill: "#20C3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_6100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.669922 0.669922)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygonIcon.406482fd340bb20658ff85e6ac8bf12d.svg";
export { ForwardRef as ReactComponent };